export const formatPrice = (price) => {
  if (isNaN(price)) return "Rp 0";

  const formattedPrice = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(price);

  return formattedPrice;
};
